import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactTextareaAutosize from 'react-textarea-autosize';

const ExpandableTextArea = React.forwardRef(({ maxRows, minRows, ...props }, ref) => {
  return <StyledTextarea maxRows={maxRows} minRows={minRows} ref={ref} {...props} />;
});

ExpandableTextArea.displayName = 'ExpandableTextArea';

ExpandableTextArea.propTypes = {
  maxRows: PropTypes.number,
  minRows: PropTypes.number,
};

ExpandableTextArea.defaultProps = {
  maxRows: 6,
  minRows: 1,
};

const StyledTextarea = styled(ReactTextareaAutosize)`
  resize: none;

  /* Custom scrollbar - only visible on overflow */
  & {
    cursor: auto;
  }
  &::-webkit-scrollbar {
    width: 12px;
    height: 12px;
  }
  &::-webkit-scrollbar-track,
  &::-webkit-scrollbar-thumb {
    background-clip: content-box;
    border: 4px solid transparent;
    border-radius: 12px;
  }
  &::-webkit-scrollbar-track {
    background-color: rgba(0, 0, 0, 0.05);
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.25);
  }
  @media (hover: hover) {
    :where(&:not(:disabled))::-webkit-scrollbar-thumb:hover {
      background-color: rgba(0, 0, 0, 0.35);
    }
  }
`;

export default ExpandableTextArea;
